import React from 'react'

export const FixedFooter: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <footer className="fixed bottom-0 flex h-[85px] w-full flex-col items-center justify-evenly bg-[#1c1a1a] px-8 text-white/60 sm:h-[65px] sm:flex-row sm:justify-between sm:px-20">
      {children}
    </footer>
  )
}
